import React from "react";
import { Dialog, DialogTitle, DialogContent, Box, Typography } from "@mui/material";

export default function CallFlowModal({ open, onClose, flowData, fmtTimeOnly, normStatus }) {
  if (!flowData || !open) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>📞 Call Flow Timeline</DialogTitle>

      <DialogContent dividers>
        {flowData.map((r, idx) => {
          const status = normStatus(r.status);
          const isLast = idx === flowData.length - 1;

          return (
            <Box key={idx} sx={{ display: "flex", mb: 2 }}>
              {/* LEFT DOT + LINE */}
              <Box sx={{ mr: 2, textAlign: "center" }}>
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    backgroundColor:
                      status === "answered"
                        ? "#4caf50"
                        : status === "missed"
                        ? "#f44336"
                        : "#616161",
                    margin: "auto",
                  }}
                />
                {!isLast && (
                  <Box
                    sx={{
                      width: 2,
                      height: 32,
                      backgroundColor: "#bdbdbd",
                      margin: "auto",
                    }}
                  />
                )}
              </Box>

              {/* RIGHT CONTENT */}
              <Box>
                <Typography variant="subtitle2">
                  {fmtTimeOnly(r.startedAt)}
                </Typography>

                <Typography>
                  {status === "answered" && "✔ Answered"}
                  {status === "missed" && "❌ Missed"}
                  {status === "abandoned" && "⚠ Abandoned"}{" "}
                  {"(" + (r.agentName || r.agentId) + ")"}
                </Typography>
              </Box>
            </Box>
          );
        })}

        {/* FINAL SUMMARY */}
        <Box
          sx={{
            mt: 3,
            p: 2,
            bgcolor: "#f5f5f5",
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          {(() => {
            const answeredCalls = flowData.filter(
              (r) => normStatus(r.status) === "answered"
            );

            if (answeredCalls.length > 0) {
              const agentNames = answeredCalls
                .map((r) => r.agentName)
                .filter((v, i, arr) => arr.indexOf(v) === i); // unique

              return (
                <Typography variant="h6" color="success.main">
                  ✔ Answered by: {agentNames.join(", ")}
                </Typography>
              );
            }

            return (
              <Typography variant="h6" color="error">
                ❗ Missed by ALL agents
              </Typography>
            );
          })()}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
